import { render, staticRenderFns } from "./ito.vue?vue&type=template&id=2eb4da3a&scoped=true&"
import script from "./ito.vue?vue&type=script&lang=js&"
export * from "./ito.vue?vue&type=script&lang=js&"
import style0 from "./ito.vue?vue&type=style&index=0&id=2eb4da3a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb4da3a",
  null
  
)

export default component.exports